// autoformats field labels, transform / compute display values, and parses values for transformed / computed fields
// Usage: extend your model (or it's prototype) with SoaModelLabelAndValueTransformer and then use it as the model
// for your rows any module that makes use of getLabelDisplayVal, getFieldDisplayVal, and / or parseFieldDisplayVal,
// e.g. ProfileViews.Profile in admin-v2
"use strict";

var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var bunsenLibs = require('bunsen/libraries/bunsen');
module.exports = {
    displayLabels: {},
    displayTransforms: {},
    defaultNeedsNoEscape: {
        email: true
    },
    defaultDisplayTransforms: {
        email: function (email) {
            return '<a href=\"mailto:' + _.escape(email) + '\">' + _.escape(email) + '</a>';
        },
        phoneNumber: bunsenLibs.formatPhoneNumber,
        fullName: function (name) {
            if (name) {
                return name;
            }
            name = _.filter([this.get('firstName'), this.get('lastName')], _.identity);
            if (_.isEmpty(name)) {
                return undefined;
            }
            return name.join(' ');
        }
    },
    defaultFieldParsers: {
        fullName: function (fullName) {
            if (fullName) {
                return fullName;
            }
            // todo: where does val come from? what is this supposed to do?
            fullName = $.trim(val).match(/^(((.+?)\s(.+\s)?(.+?))|(.*))$/i); // eslint-disable-line
            return {
                firstName: fullName[3],
                lastName: fullName[5] || fullName[6]
            };
        }
    },
    schemas: {},
    getSchema: function (fieldName) {
        var schema = this.schemas[fieldName];
        if (schema) {
            return schema;
        }
        return {type: 'Text'};
    },
    getLabelDisplayVal: function (label) {
        var displayLabel = this.displayLabels[label];
        if (!displayLabel) {
            return bunsenLibs.camel2spaceCase(label, true);
        }
        if ("function" === typeof displayLabel) {
            return displayLabel.call(this, label);
        }
        return displayLabel;
    },
    fieldNeedsEscaping: function (field) {
        if (this.needsNoEscape && this.needsNoEscape.hasOwnProperty(field)) {
            return !this.needsNoEscape[field];
        }
        if (this.defaultNeedsNoEscape && this.defaultNeedsNoEscape.hasOwnProperty(field)) {
            return !this.defaultNeedsNoEscape[field];
        }
        return true;
    },
    getFieldDisplayVal: function (field) {
        var val = this.get(field);
        var transform = this.displayTransforms[field] || this.defaultDisplayTransforms[field];
        if (transform) {
            return transform.call(this, val);
        }
        return val;
    },
    parseFieldDisplayVal: function (field, value) {
        var parser = this.fieldParsers[field] || this.defaultFieldParsers[field];
        if (parser) {
            return parser.call(this, value);
        }
        return _.object([field], [value]);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/SoaModelLabelAndValueTransformer.js
// module id = 1622
// module chunks = 64